var $loginForm = $('#log-in');
var $recoverForm = $('#recover-password');
var $addAddressForm = $('#add-address');
var $editAddressForms = $('.edit-address');
var $allAddresses = $('#addresses-list');

/*
Login
*/
$('#recover-trigger').on('click', function(e){
  e.preventDefault();
  $loginForm.hide();
  $recoverForm.fadeIn();
});
$('#recover-cancel').on('click', function(e){
  e.preventDefault();
  $recoverForm.hide();
  $loginForm.fadeIn();
});

// Allow deep linking to recover password form
// also happens on recover error
var hash = window.location.hash;
if (hash === '#recover') {
  $loginForm.hide();
  $recoverForm .show();
}

// reset message success will be in the DOM after successful submit
if ($('.reset-password-success').length) {
  $('#recover-success').show();
}

/*
Address Book
*/
$('#add-address-trigger').on('click', function(e){
  e.preventDefault();
  $allAddresses.hide();
  $editAddressForms.hide();
  $addAddressForm.fadeIn();
});
$('#add-address-cancel').on('click', function(e){
  e.preventDefault();
  $addAddressForm.hide();
  $allAddresses.fadeIn();
});

$('.edit-address-trigger').on('click', function(e){
  e.preventDefault();
  $allAddresses.hide();
  $addAddressForm.hide();
  $editAddressForms.hide();
  $('#address-' + $(this).data('form-id')).fadeIn();
});
$('.edit-address-cancel').on('click', function(){
  // no preventDefault so page jumps to top
  $editAddressForms.hide();
  $allAddresses.fadeIn();
});

$('.delete-address-trigger').on('click', function(e) {
  e.preventDefault();
  var $el = $(this);
  var formId = $el.data('form-id');
  var confirmMessage = $el.data('confirm-message');
  if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
    Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
  }
});

/*
Populate state after country changes
*/
if (typeof Shopify !== "undefined" && Shopify && $('.dynamic-options').length) {
  // Add new form
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  // Edit forms
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;
    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });
}


/*
Bill Me Later orders table cleanup. 
Note: 'draftOrdersLoaded' was added to CML_script.js on line 516
---
original: document.getElementById('CML_draft_orders').innerHTML = this.responseText;
added: jQuery('body').trigger('draftOrdersLoaded');
---
*/
$b.on('draftOrdersLoaded', function(){
  let $ordersTable = $('#CML_draft_orders .account-table');
  // our styles
  $ordersTable.addClass('responsive compressed striped');
  // returned table has everyhing in tbody
  $ordersTable.prepend('<thead/>');
  let $thead = $ordersTable.find('thead');
  $ordersTable.find('tr').first().detach().appendTo($thead);
  // alignment & responsive
  $thead.find('th').last().addClass('col-right');
  $ordersTable.find('tbody tr').each(function(){
    let $row = $(this);
    $row.find('td').last().addClass('col-right');
    $row.find('td').each(function(i){
        $(this).attr('data-label', $thead.find('th').eq(i).text());
    });
  });
  // insert a heading
  $('<h2>' + window.cmlOrdersTitle + '</h2>').insertBefore($ordersTable);
});

// Customer Fields
if (typeof CF !== 'undefined') {
  CF.ready(function() {
    $('.cf-submit-form').addClass('btn-enhanced').append(window.app.btnBorder);
  });
}
